/**
 * API Key Filters Component
 *
 * Filter controls for API keys list with client type filter.
 */

import { X } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { CLIENT_TYPES, CLIENT_TYPE_DETAILS } from '@/types/api-key';
import type { ClientType } from '@/types/api-key';

interface ApiKeyFiltersProps {
  clientType?: ClientType;
  onFilterChange: (filters: { clientType?: ClientType }) => void;
  onClearFilters: () => void;
}

/**
 * API Key Filters
 * Renders filter dropdown for client type
 */
export function ApiKeyFilters({ clientType, onFilterChange, onClearFilters }: ApiKeyFiltersProps) {
  const hasActiveFilters = clientType !== undefined;

  return (
    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
      {/* Client Type Filter */}
      <div className="w-full sm:w-48">
        <Select
          value={clientType || 'all'}
          onValueChange={value => {
            onFilterChange({
              clientType: value === 'all' ? undefined : (value as ClientType),
            });
          }}
        >
          <SelectTrigger>
            <SelectValue placeholder="All Client Types" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Client Types</SelectItem>
            {CLIENT_TYPES.map(type => (
              <SelectItem key={type} value={type}>
                {CLIENT_TYPE_DETAILS[type].label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <Button variant="ghost" size="sm" onClick={onClearFilters} className="gap-2">
          <X className="h-4 w-4" />
          Clear
        </Button>
      )}
    </div>
  );
}
